"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleTokenMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class ToggleTokenMapper {
    toDomain(result) {
        const getToggleToken = lodash_1.default.get(result, "data.getWsToken");
        return Object.assign({}, getToggleToken);
    }
}
exports.ToggleTokenMapper = ToggleTokenMapper;
